import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { IDepartmentEmps } from "../../Interfaces/ResponsesData";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class EmpListsVM extends InterActive{
    private list:IDepartmentEmps[] =[]
    private roles:{id:string , role:string}[] = []

    public get List():IDepartmentEmps[] { return this.list }
    public get Roles():{id:string , role:string}[] { return this.roles }

    public getList(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getEmpLists()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.list = response.data.data
                                this.roles = this.list.map(i=>({id:i.id , role:i.role}))
                                this.Messege = ''
                                this.update()
                            }else{
                                Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:response.data.messege})
                            }
                        }else {
                            Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
                        }
                    }
                }catch{
                    Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})

                }
            }
        )
    }
    public async passwordReset(id:string, name:string){
        try{
            const response = await ApiRequest.passwordReset(id)
            if(response){
                if(response.status === HttpStatusCode.Ok){  
                    if(response.data.status){
                        Notify({type:'success' , title:'عملية ناجحة' , body:'تم اعادة ضبط كلمة السر للقيمة الافتراضية 12345  للموظف '+name})
                    }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
            }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
        }catch{
            Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
        } 
    }
    public async deleteUser(id:string, name:string){
        try{
            const response = await ApiRequest.deleteUser(id)
            if(response){
                if(response.status === HttpStatusCode.Ok){  
                    if(response.data.status){
                        Notify({type:'success' , title:'عملية ناجحة' , body:'تم حذف للموظف '+name})
                    }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
            }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
        }catch{
            Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
        } 
    }
    public async editUser(id:string, name:string , email:string , password:string , role_id:string){
        try{
            const response = await ApiRequest.editUser(id,name , email , password , role_id)
            if(response){
                if(response.status === HttpStatusCode.Ok){  
                    if(response.data.status){
                        Notify({type:'success' , title:'عملية ناجحة' , body:'تم تعديل بيانات الموظف '+name+' بنجاح'})
                    }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
            }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
        }catch{
            Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'هناك مشكلة فى الاتصال بالشبكة .. برجاء مراجعة الاتصال بالانترنت'})
        } 
    }

    public reLocateUser(id:string , name:string , email:string , role_id:string){
        const parent = this.list.find(i => i.users.some(x => x.id === id));
        const user = parent?.users.find(x => x.id === id);
        

        if(user){
            user.name = name
            user.email = email

            this.list = this.list.map(i => ({ ...i, users: i.users.filter(x => x.id !== id)  }));
            this.list.find(a=>a.id === role_id)?.users.push(user);
        }
        this.update()
    }
        
    public async updatePermission(role_id:string , permission_id:string , value:'enable'|'disable'){
        try{
            const response = await ApiRequest.updatePermission(role_id , permission_id , value)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(!response.data.status){
                        Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }else {
                    Notify({type:'danger' , title:'فشل العميلة' , body:'فشل عملية تعديل الصلاحيات ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        }catch{

        }
    }
}